import React from 'react';
import '../styles/QuizGame.css';

/**
 * Componente riutilizzabile per i pulsanti di navigazione nei giochi.
 * 
 * @param {Object} props - Proprietà del componente
 * @param {Function} props.onNext - Funzione da eseguire quando si preme il pulsante avanti
 * @param {Function} props.onPrev - Funzione da eseguire quando si preme il pulsante indietro
 * @param {boolean} props.nextDisabled - Se il pulsante avanti deve essere disabilitato
 * @param {boolean} props.prevDisabled - Se il pulsante indietro deve essere disabilitato
 * @param {string} props.nextText - Testo da mostrare nel pulsante avanti
 * @param {string} props.prevText - Testo da mostrare nel pulsante indietro
 * @param {Object} props.style - Stili aggiuntivi per il contenitore
 * @param {string} props.className - Classe CSS aggiuntiva
 * @returns {JSX.Element} Componente pulsanti di navigazione
 */
const NavigationButtons = ({
  onNext,
  onPrev,
  nextDisabled = false,
  prevDisabled = false,
  nextText = 'Avanti',
  prevText = 'Indietro',
  style = {},
  className = ''
}) => {
  // Styles di default
  const defaultStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '400px',
    gap: '2rem',
    margin: '1rem auto',
    paddingBottom: '1.5rem',
    width: '90%'
  };

  // Combina gli stili di default con quelli personalizzati
  const combinedStyles = { ...defaultStyle, ...style };

  return (
    <div className={`quiz-navigation ${className}`} style={combinedStyles}>
      <button 
        className="quiz-button secondary"
        onClick={onPrev}
        disabled={prevDisabled}
      >
        {prevText}
      </button>
      <button 
        className="quiz-button"
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextText}
      </button>
    </div>
  );
};

export default NavigationButtons; 